import { useContext, useReducer, Dispatch, ReactNode } from 'react';

interface IContextProviderProps<T, A> {
  children: ReactNode;
  reducer: (state: T, action: A) => T;
  initialState: T;
  stateContext: React.Context<T | null>;
  dispatchContext: React.Context<Dispatch<A> | null>;
}

export function CmnContextProvider<T, A>({
  children,
  reducer,
  initialState,
  stateContext,
  dispatchContext,
}: IContextProviderProps<T, A>): JSX.Element {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <stateContext.Provider value={state}>
      <dispatchContext.Provider value={dispatch}>{children}</dispatchContext.Provider>
    </stateContext.Provider>
  );
}

export function useStateProvider<T>(context: React.Context<T | null>, errorMessage: string): T {
  const state = useContext(context);
  if (!state) {
    throw new Error(`Cannot find ${errorMessage} Provider`);
  }
  return state;
}

export function useDispatchProvider<A>(context: React.Context<Dispatch<A> | null>, errorMessage: string): Dispatch<A> {
  const dispatch = useContext(context);
  if (!dispatch) {
    throw new Error(`Cannot find ${errorMessage} Provider`);
  }
  return dispatch;
}
